<template>
  <div>
    <v-autocomplete
      ref="auto"
      v-model="municipioSolucao.municipioSolucao"
      item-text="nome"
      item-value="municipioSolucaoId"
      :items="solutions"
      :label="`${isAT ? 'Iniciativas' : 'Solução'}`"
      :placeholder="`${isAT ? 'Iniciativas' : 'Solução'}`"
      clearable
      :return-object="true"
      @change="change"
      @click="load"
      :loading="loading"
      @click:append="clickOnArrow"
    >
      <template slot="no-data">
        <div class="progress" v-if="loading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <div v-else>Nenhuma Solução retornada</div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { citySolutionAPI } from "@/modules/city";
import { mapGetters, mapActions } from "vuex";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "AppCitySolutionCombobox",
  props: {
    municipioSolucao: { municipioSolucao: {} },
  },
  data() {
    return {
      solutions: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    change(value) {
      if (value) this.municipioSolucao.municipioSolucao = value;
      else this.municipioSolucao.municipioSolucao = {};

      this.$emit("changeSolution");
    },
    clickOnArrow() {
      if (this.$refs.auto.isMenuActive == false)
        this.$refs.auto.$refs.input.click();
      else this.$refs.auto.isMenuActive = false;
    },
    load() {
      var filtros = {
        grupoSolucaoId:
          this.municipioSolucao.municipioGrupoSolucao &&
          this.municipioSolucao.municipioGrupoSolucao.municipioGrupoSolucaoId,
        municipioId: this.$route.params.id,
      };
      this.solutions = [];
      this.loading = true;
      citySolutionAPI
        .listByCity(filtros)
        .then((resp) => {
          this.solutions = resp.data
            .filter((item) => item.desabilitado === false)
            .sort((a, b) => compare(a, b, "nome"));
          this.loading = false;
        })
        .catch((resp) => {
          this.loading = false;
          this.$notification.error(
            `Erro ao listar ${this.isAT ? "iniciativas" : "soluções"}`
          );
        });
    },
  },
};
</script>
<style scoped>
.progress {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
